import { render, staticRenderFns } from "./WorkerCreate.vue?vue&type=template&id=3773130d&"
import script from "./WorkerCreate.vue?vue&type=script&lang=js&"
export * from "./WorkerCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports